import React, { useState } from 'react';

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import Button from 'CommonComponents/Button';

export default function SportOfficialsIndexTableRow(props) {
    const [editing, setEditing] = useState(false);
    const [officialId, setOfficialId] = useState(props.official.id);
    const [firstName, setFirstName] = useState(props.official.first_name ?? '');
    const [lastName, setLastName] = useState(props.official.last_name ?? '');
    const [nationality, setNationality] = useState(
        props.official.nationality ? { value: props.official.nationality, label: props.official.nationality } : { value: '', label: $t('Undisclosed') },
    );
    const [gender, setGender] = useState(
        props.official.gender ? { value: props.official.gender, label: props.official.gender_label } : { value: '', label: $t('Undisclosed') },
    );
    const [roleDescription, setRoleDescription] = useState(props.official.role_description ?? '');
    const [request, setRequest] = useState(false);

    const genders = [
        { value: '', label: $t('Undisclosed') },
        { value: 'Male', label: $t('Male') },
        { value: 'Female', label: $t('Female') },
    ];

    const toggleEditing = () => {
        setEditing(!editing);
    };

    const saveOfficial = () => {
        setRequest(true);
        axios
            .put(sportOfficialsUpdateUrl.replace('OFFICIAL_ID', officialId), {
                first_name: firstName,
                last_name: lastName,
                nationality: nationality.value,
                gender: gender.value,
                role_description: roleDescription,
            })
            .then((res) => {
                setRequest(false);
                setFirstName(res.data.official.first_name ?? '');
                setLastName(res.data.official.last_name ?? '');
                setNationality({ value: res.data.official.nationality ?? '', label: res.data.official.nationality ?? 'Undisclosed' });
                setGender({ value: res.data.official.gender ?? '', label: res.data.official.gender_label });
                setEditing(false);
            })
            .catch((error) => {
                setRequest(false);
                props.setError('There was an error updating official');
            });
    };

    const handleChangeField = (event) => {
        switch (event.target.id) {
            case 'firstName':
                setFirstName(event.target.value);
                break;
            case 'lastName':
                setLastName(event.target.value);
                break;
            case 'roleDescription':
                setRoleDescription(event.target.value);
                break;
        }
    };

    function handleChangeNationality(option) {
        setNationality(option);
    }

    function handleChangeGender(option) {
        setGender(option);
    }

    return (
        <>
            <tr className={'cursor-pointer'}>
                <td>{props.officialIndex}</td>

                {editing && (
                    <td>
                        <input
                            type="text"
                            step="1"
                            name={`firstName`}
                            className="form-control"
                            id={`firstName`}
                            value={firstName}
                            onChange={(event) => handleChangeField(event)}
                        />
                    </td>
                )}
                {!editing && <td>{firstName}</td>}

                {editing && (
                    <td>
                        <input
                            type="text"
                            step="1"
                            name={`lastName`}
                            className="form-control"
                            id={`lastName`}
                            value={lastName}
                            onChange={(event) => handleChangeField(event)}
                        />
                    </td>
                )}
                {!editing && <td>{lastName}</td>}

                {editing && (
                    <td>
                        <CreatableSelect
                            name="select_nationality"
                            options={props.nationalities}
                            onChange={handleChangeNationality}
                            defaultValue={{
                                value: '',
                                label: 'Undisclosed',
                            }}
                            value={nationality}
                            menuPlacement={props.officialIndex < props.pageUseTopIndex ? 'bottom' : 'top'}
                        />
                    </td>
                )}
                {!editing && <td>{nationality.value}</td>}

                {editing && (
                    <td>
                        <Select
                            name="select_gender"
                            options={genders}
                            onChange={handleChangeGender}
                            defaultValue={{
                                value: '',
                                label: $t('Undisclosed'),
                            }}
                            value={gender}
                            menuPlacement={props.officialIndex < props.pageUseTopIndex ? 'bottom' : 'top'}
                        />
                    </td>
                )}
                {!editing && <td>{gender.value ? gender.label : ''}</td>}

                {<td>{props.officialRole}</td>}

                {editing && (
                    <td>
                        <input
                            type="text"
                            step="1"
                            name={`roleDescription`}
                            className="form-control"
                            id={`roleDescription`}
                            value={roleDescription}
                            onChange={(event) => handleChangeField(event)}
                        />
                    </td>
                )}
                {!editing && <td>{roleDescription}</td>}

                {<td>{props.arrivalDate}</td>}

                {<td>{props.departureDate}</td>}

                <td>
                    <div className="tw-flex tw-items-center tw-gap-x-2">
                        {editing && (
                            <Button small variant="primary" style={{ minWidth: '4rem' }} onClick={() => saveOfficial()} disabled={request}>
                                {$t('Save')}
                            </Button>
                        )}
                        {editing && (
                            <Button small variant="danger" style={{ minWidth: '4rem' }} onClick={() => setEditing(false)}>
                                {$t('Cancel')}
                            </Button>
                        )}
                        {!editing && (
                            <Button small variant="primary" style={{ minWidth: '4rem' }} onClick={() => toggleEditing()}>
                                {$t('Edit')}
                            </Button>
                        )}
                        {!editing && (
                            <Button small variant="danger" style={{ minWidth: '4rem' }} onClick={() => props.setDeletedOfficial(props.official)}>
                                {$t('Delete')}
                            </Button>
                        )}
                    </div>
                </td>
            </tr>
        </>
    );
}
